import React from 'react'
import PropTypes from 'prop-types'
import {Small, withTooltip} from '@modifi/ui'
import {ProductType} from '@modifi/enums'
import {useTranslation} from '@modifi/plugin-i18n'
import {white, landGreen} from '@modifi/colors'
import {formatHumanReadable} from '@codeplant-de/iban-utils'
import {NameTag, Capitalize} from './styles'
import {BANK_TYPE_RECIPIENT, BANK_TYPE_SENDER} from '../../constants'

const NameTagWithTooltip = withTooltip(NameTag)

const BankCard = ({
  bankType,
  bankName,
  bankAccountHolder,
  bankAccountNumber,
  bankCode,
  refinancingProvider1,
  refinancingProvider2,
  bankProvider,
  productType,
}) => {
  const {t} = useTranslation('moneta')
  return (
    <>
      {bankType && (
        <strong>
          <Capitalize>{bankType}</Capitalize> Bank Details
        </strong>
      )}
      <p>
        {bankName && (
          <>
            {bankName}
            <br />
          </>
        )}
        {bankAccountHolder}
        <br />
        {formatHumanReadable(bankAccountNumber)}
        <br />
        {t('unmatched-transaction.bank-card.bank-code.label', {bankCode})}
      </p>
      {refinancingProvider1 && (
        <NameTagWithTooltip
          tooltipContent={t(
            `unmatched-transaction.bank-card.refinancing-provider.${
              refinancingProvider2 ? 'has-fallback.' : ''
            }tooltip`,
            {
              refinancingProvider1,
              refinancingProvider2,
            }
          )}
        >
          <Small color={white}>{`${refinancingProvider1}${
            refinancingProvider2 ? ` (${refinancingProvider2})` : ''
          }`}</Small>
        </NameTagWithTooltip>
      )}
      {productType === ProductType.SELLER_FINANCING && bankProvider && (
        <NameTagWithTooltip
          tooltipContent={t('unmatched-transaction.bank-card.bank-provider.tag.tooltip')}
          color={landGreen}
        >
          <Small color={white}>{bankProvider === 'MODIFI' ? 'DEU_BA' : bankProvider}</Small>
        </NameTagWithTooltip>
      )}
    </>
  )
}

BankCard.propTypes = {
  bankType: PropTypes.oneOf([BANK_TYPE_SENDER, BANK_TYPE_RECIPIENT]),
  bankName: PropTypes.string,
  bankAccountHolder: PropTypes.string.isRequired,
  bankAccountNumber: PropTypes.string.isRequired,
  bankCode: PropTypes.string.isRequired,
  refinancingProvider1: PropTypes.string,
  refinancingProvider2: PropTypes.string,
  bankProvider: PropTypes.string,
  productType: PropTypes.string,
}

BankCard.defaultProps = {
  bankType: null,
  bankName: null,
  refinancingProvider1: null,
  refinancingProvider2: null,
  bankProvider: null,
  productType: null,
}

export default BankCard
